/* src/app/core/pages/tfa/tfa.component.scss */
.otp-container ::ng-deep .p-inputotp .p-inputtext {
  font-size: 0.875rem;
  padding: 0.65rem 0.65rem;
}
.otp-container ::ng-deep .p-inputotp .p-inputotp-input {
  width: 2rem;
}
.otp-container ::ng-deep .p-button {
  width: 100%;
  padding: 0.75rem 0.5rem;
  font-size: 0.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.875rem;
}
.spinner svg {
  width: 6rem;
  transform-origin: center;
  animation: rotate4 2s linear infinite;
}
.spinner circle {
  fill: none;
  stroke: var(--primary-color);
  stroke-width: 2;
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  stroke-linecap: round;
  animation: dash4 1.5s ease-in-out infinite;
}
@keyframes rotate4 {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes dash4 {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dashoffset: -125px;
  }
}
/*# sourceMappingURL=tfa.component.css.map */
